<template>
  <div class="flex w-full gap-8 p-6">
    <div class="w-1/4 space-y-1">
      <h3 class="font-semibold text-dark-neutral-500">
        Oxford level of evidence
      </h3>
      <p class="text-sm text-gray-600 font-light">
        Grade evidence quality for prognosis, diagnosis, treatment, and
        screening.
      </p>
    </div>
    <div class="w-full">
      <SectionCard
        class="w-full"
        title="Oxford level of evidence"
        subtitle="The Oxford CEBM Levels of Evidence is a grading systems for assessing the quality of evidence for claims about prognosis, diagnosis, treatment benefits, treatment harms, and screening."
        :display-content="false"
      >
        <template #header-button>
          <PlanLockGuard>
            <Switch
              :disabled="review.isPlanReadonly.value"
              :model-value="
                review.entity.value?.plan?.appraisalPlan
                  .isOxfordLevelOfEvidenceApplicable
              "
              @update:model-value="toggleAppraisalIsOxfordLevelOfEvidence"
            >
              <template #icon>
                <component
                  :is="
                    review.entity.value?.plan?.appraisalPlan
                      .isOxfordLevelOfEvidenceApplicable
                      ? ArrowsPointingInIcon
                      : ArrowsPointingOutIcon
                  "
                  class="w-3 h-auto"
                  :class="
                    review.entity.value?.plan?.appraisalPlan
                      .isOxfordLevelOfEvidenceApplicable
                      ? 'text-green-500'
                      : 'text-dark-neutral-100'
                  "
                />
              </template>
            </Switch>
          </PlanLockGuard>
        </template>
      </SectionCard>
    </div>
  </div>
</template>

<script setup lang="ts">
import Switch from '@app/components/Global/Switch.vue'
import { injectStrict } from '@app/utils/injectStrict'
import { ReviewKey } from '@app/views/Review/use-review'
import { HttpException } from '@core/exceptions/http.exception'
import useSnackbar from '@app/composables/use-snackbar'
import { SnackbarState } from '@app/types'
import useLoading from '@app/composables/use-loading'
import SectionCard from '@app/components/Global/SectionCard.vue'
import {
  ArrowsPointingOutIcon,
  ArrowsPointingInIcon,
} from '@heroicons/vue/24/outline'
import PlanLockGuard from '../PlanLockGuard.vue'

const review = injectStrict(ReviewKey)
const snackbar = useSnackbar()
const loading = useLoading()
async function toggleAppraisalIsOxfordLevelOfEvidence() {
  loading.start()
  try {
    if (
      review.entity.value?.plan?.appraisalPlan.isOxfordLevelOfEvidenceApplicable
    ) {
      await review.disableStudiesAppraisalOxfordLevelOfEvidence()
      snackbar.success('Success')
    } else {
      await review.enableStudiesAppraisalOxfordLevelOfEvidence()
      snackbar.success('Success')
    }
  } catch (e) {
    const error = e as HttpException
    if (
      error.response.data.statusCode >= 400 &&
      error.response.data.statusCode < 500
    ) {
      snackbar.show(SnackbarState.ERROR, error.response.data.message)
    } else {
      snackbar.show(
        SnackbarState.ERROR,
        'An error occured while enabling/disabling appraisal oxford level of evidence, please try again.',
      )
    }
    throw e
  } finally {
    loading.stop()
  }
}
</script>
